// Types for Accounting module
export interface IncomingInvoiceBaseFields {
  sharedWithProjectIds: string[];
  sharedWithOfficeIds: string[];
  notes: string;
  invoiceNumber: string;
  date: Date;
  currency: string;
  periodOfPerformanceFrom: Date;
  periodOfPerformanceTo: Date;
  cashDiscountPercent: number;
  cashDiscountDays: number;
  totalExcludingVat: number;
  totalIncludingVat: number;
  totalVat: number;
  amountToTransfer: number;
  dueDate: Date;
  fromOfficeId: string;
  fromOfficeName: string;
  toOfficeId: string;
}

export interface IncomingInvoiceDto extends IncomingInvoiceBaseFields {
  incomingInvoiceId: string;
  createdBy: string;
  createdAt: Date;
  originalAnalyzationResult: IncomingInvoiceBaseFields | null;
  fileLocation: string;
  approvedBy?: string;
  approvedAt?: Date;
  incomingInvoiceState: EIncomingInvoiceState;
  isExported: boolean;
}

export interface UpdateIncomingInvoiceDto {
  notes?: string;
  invoiceNumber?: string;
  date?: Date;
  currency?: string;
  periodOfPerformanceFrom?: Date;
  periodOfPerformanceTo?: Date;
  cashDiscountPercent?: number;
  cashDiscountDays?: number;
  totalExcludingVat?: number;
  totalIncludingVat?: number;
  totalVat?: number;
  sharedWithProjectIds?: string[];
  sharedWithOfficeIds?: string[];
}

export enum EIncomingInvoiceState {
  Processing = 'processing',
  Draft = 'draft',
  ApprovalRequested = 'approvalRequested',
  Rejected = 'rejected',
  Approved = 'approved',
  MissingFile = 'missingFile',
}

export enum EFinancialDocumentType {
  IncomingInvoice = 'incomingInvoice',
  OutgoingInvoice = 'outgoingInvoice',
}

export interface FinancialDocumentAllocation {
  financialDocumentAllocationId: string;
  financialDocumentId: string;
  financialDocumentType: EFinancialDocumentType;
  projectId: string;
  projectPhaseId?: string;
  amount: number;
}

export interface IncomingInvoiceUploadRequest {
  file: File;
  fileLanguage?: string;
}

export interface IncomingInvoiceListResponse {
  invoices: IncomingInvoiceDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface ApprovalRequest {
  incomingInvoiceId: string;
  approverNotes?: string;
}

export interface ApprovalResponse {
  invoice: IncomingInvoiceDto;
  approvedAt: Date;
  approvedBy: string;
}

export type InvoiceKey = keyof IncomingInvoiceBaseFields;
export interface IncomingInvoiceFieldDiff {
  key: InvoiceKey;
  invoiceValue: IncomingInvoiceBaseFields[InvoiceKey] | null;
  analyzedValue: IncomingInvoiceBaseFields[InvoiceKey] | null;
  decision?: {
    value: IncomingInvoiceBaseFields[InvoiceKey] | null;
  };
  analyzedFromPair?: boolean;
}

export type IncomingInvoiceDiff = {
  incomingInvoiceId: string;
  diffs: IncomingInvoiceFieldDiff[];
};
